import React from "react";
import { FaHome, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../../assets/css/components/general/pageHero/PageHero.css";

/*
  =============================================
  REUSABLE PAGE HERO COMPONENT - KisaanMart
  =============================================
  Props:
  - title       : string  — Page ka main heading  (e.g. "Our Shops")
  - breadcrumb  : string  — Current page name     (e.g. "Shops")
  - icon        : node    — React Icon component  (e.g. <FaStore />)
  - bgImage     : string  — Background image URL  (optional, default farm image)
  - overlayType : string  — "green" | "dark" | "mixed"  (default: "mixed")
  =============================================
  Usage Examples:

  // Shops Page
  <PageHero
    title="Our Shops"
    breadcrumb="Shops"
    icon={<FaStore />}
  />

  // Contact Page
  <PageHero
    title="Contact Us"
    breadcrumb="Contact"
    icon={<FaEnvelope />}
    bgImage="https://your-image-url.jpg"
    overlayType="dark"
  />

  // About Page
  <PageHero
    title="About Us"
    breadcrumb="About"
    icon={<FaLeaf />}
    overlayType="green"
  />

  // Products Page
  <PageHero
    title="Our Products"
    breadcrumb="Products"
    icon={<FaBoxOpen />}
  />
  =============================================
*/

const DEFAULT_BG =
  "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1600";

const PageHero = ({
  title = "Page Title",
  breadcrumb = "Page",
  icon = null,
  bgImage = DEFAULT_BG,
  overlayType = "mixed",
}) => {
  return (
    <div className={`page-hero page-hero--overlay-${overlayType}`}>
      {/* Background Image */}
      <div className="page-hero__bg">
        <img src={bgImage} alt={title} className="page-hero__bg-img" />
        <div className="page-hero__overlay" />
      </div>

      {/* Decorative shapes */}
      <span className="page-hero__deco page-hero__deco--1" aria-hidden="true" />
      <span className="page-hero__deco page-hero__deco--2" aria-hidden="true" />
      <span className="page-hero__deco page-hero__deco--3" aria-hidden="true" />

      {/* Main Content */}
      <div className="page-hero__content">
        {/* Icon Badge */}
        {icon && <div className="page-hero__icon-badge">{icon}</div>}

        {/* Title */}
        <h1 className="page-hero__title">{title}</h1>

        {/* Divider */}
        <div className="page-hero__divider" aria-hidden="true">
          <span className="page-hero__divider-line" />
          <span className="page-hero__divider-dot" />
          <span className="page-hero__divider-line" />
        </div>

        {/* Breadcrumb */}
        <nav className="page-hero__breadcrumb" aria-label="breadcrumb">
          <Link to="/" className="page-hero__breadcrumb-link">
            <FaHome className="page-hero__breadcrumb-home" />
            Home
          </Link>
          <FaChevronRight className="page-hero__breadcrumb-arrow" />
          <span className="page-hero__breadcrumb-current">{breadcrumb}</span>
        </nav>
      </div>
    </div>
  );
};

export default PageHero;
